<div class="btn-group-vertical d-flex control-panel-right">
  <button [attr.data-btnId]="getElementId('openGeneralSettings')" class="btn btn-outline-info"
          (click)="toggleOverlay(generalSettings, $event);"
          ngbTooltip="{{'Map settings' | translate}}" placement="left">
    <i class="fas fa-cog fa-lg"></i>
  </button>
  <button [attr.data-btnId]="getElementId('openMapTools')" type="button" class="btn btn-outline-info"
          (click)="toggleOverlay(mapTools, $event);"
          ngbTooltip="{{'Map tools' | translate}}">
    <span class="fa-stack fa-lg" style="height: 1em; width: 1em">
      <i class="fas fa-screwdriver fa-inverse fa-stack-1x"></i>
      <i class="fas fa-wrench fa-stack-1x fa-inverse fa-rotate-270"></i>
    </span>
  </button>
  <button
    [attr.data-btnId]="getElementId('openFavorites')"
    type="button"
    class="btn btn-outline-info"
    (click)="toggleOverlay(favorites, $event);"
    ngbTooltip="{{'Favorites' | translate}}"
    *qmAuth="'favorites'">
    <i class="fas fa-star fa-lg"></i>
  </button>
</div>

<qm-overlay-panel #controlOverlay [stickTo]="'left-top'" [appendTo]="'body'" [dismissable]="dismissable">
  <div class="card" style="background: grey">
    <ng-container *ngTemplateOutlet="selectedTemplate"></ng-container>
  </div>
</qm-overlay-panel>

<ng-template #generalSettings>
  <div class="card text-center">
    <div class="card-body" [ngSwitch]="generalSettingsView">
      <ng-container *ngSwitchCase="'MAP'">
        <qm-map-settings></qm-map-settings>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #mapTools>
  <div class="card text-center">
    <div class="card-header settings-header">
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
          <a class="nav-link" [class.active]="selectedMapTool === 'addressSearch'"
             (click)="clearMeasures(); selectedMapTool = 'addressSearch';"
             ngbTooltip="{{'Directions' | translate}}">
            <i class="far fa-directions fa-lg"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link"
             [class.active]="selectedMapTool === 'distance'" (click)="setMeasureDistanceOn()"
             ngbTooltip="{{'Measure distance' | translate}}">
            <i class="far fa-arrows-h"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [class.active]="selectedMapTool === 'area'" (click)="setMeasureAreaOn()"
            ngbTooltip="{{'Measure area' | translate}}">
            <i class="far fa-expand fa-lg"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body" [ngSwitch]="selectedMapTool">
      <ng-container *ngSwitchCase="'addressSearch'">
        <qm-directions></qm-directions>
      </ng-container>
      <ng-container *ngSwitchCase="'distance'">
        <div *ngIf="(measureResult$ | async) === '--.--'" class="tool-description">{{ 'Start measuring distance by clicking at least two points on the map.' | translate }}</div>
        <div>{{measureResult$ | async}}</div>
        <ng-container *ngTemplateOutlet="clearMeasurementsBtn"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'area'">
        <div *ngIf="(measureResult$ | async) === '--.--'" class="tool-description">{{ 'Start measuring area by clicking at least three points on the map.' | translate }}</div>
        <div>{{measureResult$ | async}}</div>
        <ng-container *ngTemplateOutlet="clearMeasurementsBtn"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #favorites>
  <qm-favorite></qm-favorite>
</ng-template>

<ng-template #clearMeasurementsBtn>
  <button
    *ngIf="(measureResult$ | async) !== '--.--'"
    class="btn btn-outline-primary"
    [ngStyle]="{ fontSize: '.6em', padding: '.3em' }"
    (click)="onClearBtnClicked()">
    {{ 'Clear' | translate }}
  </button>
</ng-template>
